import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss'],
})
export class SignupComponent implements OnInit {

  showphone:boolean=false;
  showemail:boolean=false;
  showtchat:boolean=true;

  showgoodname:boolean=false;
  showbadname:boolean=false;

  showgoodemail:boolean=false;
  showbademail:boolean=false;

  constructor() { }

  ngOnInit() {}

  async createaccount(){
    
  }

}
